const sortPlaylists = function blacklistAndSortPlaylists(res, blacklist) {
  return res.data.items
    .filter(item => !blacklist.includes(item.id))
    .sort((a, b) => {
      if (a.snippet.title.toUpperCase() < b.snippet.title.toUpperCase()) {
        return -1;
      }
      if (a.snippet.title.toUpperCase() > b.snippet.title.toUpperCase()) {
        return 1;
      }
      return 0;
    });
};

export default sortPlaylists;



// WEBPACK FOOTER //
// ./src/components/getPlaylists/sortPlaylists.js